import script from "./moProdListTabRow.vue?vue&type=script&setup=true&lang=js"
export * from "./moProdListTabRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__